/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * Created by Tasos Kolokathis on 24/4/23.
 */

export const setCookie = (name, value, days) => {
	let expires = "";
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = date.toUTCString();
	}
	document.cookie = `${name}=${value || ""}; expires=${expires}; path=/`;
};

export const getCookie = (name) => {
	const cookies = document.cookie.split(";")
							.map(v => v.split("="))
							.reduce((acc, v) => {
								acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1]?.trim() ?? "");
								return acc;
							}, {});
	return cookies[name];
};